module.exports = __webpack_public_path__ + "static/media/fire-water-icon@2x.2ec21003.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/fire-water-icon@2x.png
// module id = 1257
// module chunks = 0